import { OCEANO } from "./oceano";
import { extendPreset } from "./types";

const CYAN = "#00E5FF";
const CYAN_RGB = "0, 229, 255";
const VIOLET = "#9D7CFF";
const DEEP = "#020B14";

/**
 * "Abissal" preset: dark and technological, with bioluminescent glows
 */
export const ABISSAL = extendPreset(OCEANO, {
  id: "abissal",
  defaults: {
    source: CYAN,
    variant: "tonal_spot",
    mode: "dark",
  },
  preview: {
    background: DEEP,
    surface: "#0A1B2A",
    primary: CYAN,
    accent: VIOLET,
  },
  accent: VIOLET,
  surfaceChroma: 8,
  shadows: {
    "1": `0 0 0 1px rgba(${CYAN_RGB}, 0.10), 0 2px 6px rgba(0, 0, 0, 0.5)`,
    "2": `0 0 0 1px rgba(${CYAN_RGB}, 0.14), 0 0 12px rgba(${CYAN_RGB}, 0.12)`,
    "3": `0 0 0 1px rgba(${CYAN_RGB}, 0.18), 0 0 18px rgba(${CYAN_RGB}, 0.18)`,
    "4": `0 0 0 1px rgba(${CYAN_RGB}, 0.22), 0 0 28px rgba(${CYAN_RGB}, 0.22)`,
  },
  gradients: {
    auth: `radial-gradient(circle at 20% 20%, rgba(${CYAN_RGB}, 0.25) 0%, transparent 40%), radial-gradient(circle at 80% 70%, rgba(157, 124, 255, 0.22) 0%, transparent 45%), ${DEEP}`,
  },
  components: {
    nav: {
      indicator: CYAN,
      unread: CYAN,
      "header-bg": `linear-gradient(135deg, #06283D, ${DEEP})`,
      "badge-bg": VIOLET,
      "badge-fg": DEEP,
    },
    message: {
      "hover-bg": `rgba(${CYAN_RGB}, 0.06)`,
      "mention-bg": `rgba(${CYAN_RGB}, 0.10)`,
      "mention-bar": CYAN,
      "new-line": CYAN,
      "new-bg": CYAN,
      "new-fg": DEEP,
    },
    code: {
      bg: DEEP,
      border: `rgba(${CYAN_RGB}, 0.25)`,
    },
    quote: {
      "nested-bg": "rgba(157, 124, 255, 0.12)",
      "nested-bar": VIOLET,
    },
    call: {
      speaking: CYAN,
    },
    tooltip: {
      bg: DEEP,
      shadow: `0 0 12px rgba(${CYAN_RGB}, 0.25)`,
    },
  },
});
